import { create, select } from "../utils";
import Swiper from "swiper";
import { Navigation, Pagination } from "swiper/modules";
import locale from "../locale/it.json";
import { ModalOptions, GuitarInfo } from "../types";
import { state } from "./state";

import diapason from "./../images/guitars/boom/diapason/diapason_cover.webp";
import diapasonPickUp from "./../images/guitars/boom/diapason/BOOM_DIAPASON_Pick-up a manico.webp";
import diapasonBridge from "./../images/guitars/boom/diapason/BOOM_DIAPASON_Ponte.webp";
import diapasonKeyboard from "./../images/guitars/boom/diapason/BOOM_DIAPASON_Tastiera.webp";
import tretrecinque from "./../images/guitars/roar/tretrecinque/ROAR_TRETRECINQUE_principlale.webp";
import tretrecinqueKeyboard from "./../images/guitars/roar/tretrecinque/ROAR_TRETRECINQUE_Segnatasti.webp";
import tretrecinquePickUp from "./../images/guitars/roar/tretrecinque/ROAR_TRETRECINQUE_Pick up.webp";
import tretrecinqueBridge from "./../images/guitars/roar/tretrecinque/ROAR_TRETRECINQUE_Ponte.webp";
import venere from "./../images/guitars/roar/venere/ROAR_VENERE_principale.webp";
import venereBridge from "./../images/guitars/roar/venere/ROAR VENERE_Ponte.webp";
import venerePickUp from "./../images/guitars/roar/venere/ROAR_VENERE_Pickup.webp";
import venereKeyboard from "./../images/guitars/roar/venere/ROAR_VENERE_Segnatasti.webp";
import mono from "./../images/guitars/slurp/mono/SLURP_MONO_principale.webp";
import monoPickup from "./../images/guitars/slurp/mono/SLURP_MONO_pickup.webp";
import monoNeck from "./../images/guitars/slurp/mono/SLURP_MONO_Manico.webp";
import monoMark from "./../images/guitars/slurp/mono/SLURP_MONO_Marchio.webp";
import pinderbass from "./../images/guitars/slurp/pinderbass/SLURP_PINDERBASS_principale.webp";
import pinderbassBridge from "./../images/guitars/slurp/pinderbass/SLURP_PINDERBASS_Ponte.webp";
import pinderbassWoods from "./../images/guitars/slurp/pinderbass/SLURP_PINDERBASS_legni.webp";
import pinderbassEq from "./../images/guitars/slurp/pinderbass/SLURP_PINDERBASS_Equalizzazione.webp";
import icarus from "./../images/guitars/wow/icarus/Principale.webp";
import icarusFingerboard from "./../images/guitars/wow/icarus/Tastiera.webp";
import icarusHeadstock from "./../images/guitars/wow/icarus/Paletta.webp";
import icarusNeck from "./../images/guitars/wow/icarus/Manico basculante.webp";
import klein from "./../images/guitars/wow/klein/WOW_KLEIN_principale.webp";
import kleinPickUp from "./../images/guitars/wow/klein/WOW_KLEIN_Pickup.webp";
import kleinBridge from "./../images/guitars/wow/klein/WOW_KLEIN_Ponte.webp";
import kleinMark from "./../images/guitars/wow/klein/WOW_KLEIN_Meccaniche e marchio.webp";
import lv from "./../images/guitars/roar/lv/Generale.webp";
import lvSoundhole from "./../images/guitars/roar/lv/Buca.webp";
import lvHeadstock from "./../images/guitars/roar/lv/Paletta_2.webp";
import lvRosette from "./../images/guitars/roar/lv/Tasti e rosetta.webp";
import volteggio from "./../images/guitars/slurp/volteggio/Principale.webp";
import volteggioInlays from "./../images/guitars/slurp/volteggio/Intarsi.webp";
import volteggioName from "./../images/guitars/slurp/volteggio/Name.webp";
import volteggioBridge from "./../images/guitars/slurp/volteggio/Ponte.webp";
import spring from "./../images/guitars/slurp/spring/SLURP_SPRING_principale.webp";
import springMark from "./../images/guitars/slurp/spring/Meccaniche.webp";
import springTail from "./../images/guitars/slurp/spring/Tailpiece.webp";
import springWoods from "./../images/guitars/slurp/spring/Legni.webp";
import miscellanea from "./../images/guitars/slurp/miscellanea/Generale.webp";
import miscellaneaInlays from "./../images/guitars/slurp/miscellanea/Intarsi_1.webp";
import miscellaneaName from "./../images/guitars/slurp/miscellanea/Name.webp";
import miscellaneaNeck from "./../images/guitars/slurp/miscellanea/Neck-through.webp";
import felipe from "./../images/guitars/slurp/felipe/SLURP_FELIPE_Principale.webp";
import felipeNeck from "./../images/guitars/slurp/felipe/Manico.webp";
import felipeName from "./../images/guitars/slurp/felipe/Nome.webp";
import felipeBridge from "./../images/guitars/slurp/felipe/Pickup ponte.webp";
import monoblocco from "./../images/guitars/boom/monoblocco/BOOM_MONOBLOCCO_principale.webp";
import monobloccoBridge from "./../images/guitars/boom/monoblocco/BOOM_MONOBLOCCO_Ponte.webp";
import monobloccoNeck from "./../images/guitars/boom/monoblocco/BOOM_MONOBLOCCO_Giunzione manico.webp";
import monobloccoWoods from "./../images/guitars/boom/monoblocco/BOOM_MONOBLOCCO_Legni.webp";

import filosophyImg from "../images/about/Filosophy.webp";
import qualityImg from "../images/about/Quality.webp";
import conceptImg from "../images/about/Concept.webp";
import biographyImg from "../images/about/Biography.webp";

const aboutImageMap: Record<string, string> = {
  filosofy: filosophyImg,
  concept: conceptImg,
  quality: qualityImg,
  biography: biographyImg,
};

const guitarCoverMap = {
  diapason,
  monoblocco,
  spring,
  volteggio,
  miscellanea,
  lv,
  tretrecinque,
  venere,
  felipe,
  mono,
  pinderbass,
  icarus,
  klein,
};

/**
 * Function to get guitar information based on the element name.
 * It retrieves the guitar data from the locale and constructs the necessary HTML elements.
 *
 * @param elementName - The name of the guitar or series element.
 * @returns An object containing guitar information or null if not found.
 */
const getInfo = (elementName: string): GuitarInfo | null => {
  let data: any = (locale as any)[elementName];

  if (!data) {
    for (const sectionKey of Object.keys(locale)) {
      const section = (locale as any)[sectionKey];
      if (section.guitars && Array.isArray(section.guitars)) {
        for (const guitarObj of section.guitars) {
          const guitarKey = Object.keys(guitarObj)[0];
          if (guitarKey.toLowerCase() === elementName.toLowerCase()) {
            data = guitarObj[guitarKey];
            break;
          }
        }
      }
      if (data) break;
    }
  }

  if (!data) {
    console.warn("[openModal]: No guitar found.", {
      name: elementName,
      data: data,
    });
    return null;
  }

  const images: string[] = [];
  const table = create("table") as HTMLTableElement;

  switch (elementName) {
    case "diapason":
      images.push(diapason, diapasonPickUp, diapasonBridge, diapasonKeyboard);
      break;
    case "tretrecinque":
      images.push(
        tretrecinque,
        tretrecinqueKeyboard,
        tretrecinquePickUp,
        tretrecinqueBridge,
      );
      break;
    case "venere":
      images.push(venere, venereBridge, venerePickUp, venereKeyboard);
      break;
    case "mono":
      images.push(mono, monoPickup, monoNeck, monoMark);
      break;
    case "pinderbass":
      images.push(pinderbass, pinderbassBridge, pinderbassWoods, pinderbassEq);
      break;
    case "klein":
      images.push(klein, kleinPickUp, kleinBridge, kleinMark);
      break;
    case "icarus":
      images.push(icarus, icarusFingerboard, icarusHeadstock, icarusNeck);
      break;
    case "felipe":
      images.push(felipe, felipeNeck, felipeName, felipeBridge);
      break;
    case "monoblocco":
      images.push(
        monoblocco,
        monobloccoBridge,
        monobloccoNeck,
        monobloccoWoods,
      );
      break;
    case "spring":
      images.push(spring, springMark, springTail, springWoods);
      break;
    case "volteggio":
      images.push(volteggio, volteggioInlays, volteggioName, volteggioBridge);
      break;
    case "miscellanea":
      images.push(
        miscellanea,
        miscellaneaInlays,
        miscellaneaName,
        miscellaneaNeck,
      );
      break;
    case "lv":
      images.push(lv, lvSoundhole, lvHeadstock, lvRosette);
      break;
    case "wow":
      images.push(icarus, icarusFingerboard, klein, kleinPickUp, kleinBridge, kleinMark);
      break;
    case "roar":
      images.push(
        lv,
        lvSoundhole,
        tretrecinque,
        tretrecinquePickUp,
        venere,
        venereBridge,
      );
      break;
    case "boom":
      images.push(diapason, diapasonPickUp, monoblocco, monobloccoBridge);
      break;
    case "slurp":
      images.push(
        mono,
        monoPickup,
        pinderbass,
        pinderbassBridge,
        felipeName,
        spring,
        miscellanea,
        volteggio,
      );
      break;
  }

  const swiper = new Swiper(".mySwiper", {
    modules: [Navigation, Pagination],
    slidesPerView: "auto",
    spaceBetween: 20,
    centeredSlides: false,
    loop: true,
    pagination: {
      el: ".swiper-pagination",
      clickable: true,
      enabled: false,
    },
  });

  const swiperWrapper = select(".swiper-wrapper");
  if (swiperWrapper) {
    swiperWrapper.innerHTML = ""; // reset

    for (const image of images.slice(1)) {
      const div = create("div");
      if (div) {
        div.classList.add("swiper-slide");
        const img = create("img");
        if (img) {
          img.src = image;
          img.alt = data.title;
          div.appendChild(img);
        }
        swiperWrapper.appendChild(div);
      }
    }
  }

  swiper.update();

  if (table && data.dataSheet) {
    Object.keys(data.dataSheet).forEach((key) => {
      const tr = create("tr");
      const th = create("th");
      const td = create("td");
      if (tr && th && td) {
        th.textContent = key;
        td.textContent = data.dataSheet[key];
        tr.appendChild(th);
        tr.appendChild(td);
        table.appendChild(tr);
      }
    });
  }

  return {
    title: data.title,
    description: data.description,
    dataSheet: data.dataSheet,
    images,
    table,
  };
};

const onOpenModal = (
  elName: string,
  options: ModalOptions = { section: null, typology: null },
): void => {
  if (!elName || !options || !options.section) {
    console.warn("[openModal]: No element or section provided.");
    return;
  }

  const title = select(".modal__title");
  const description = select(".modal__description");
  const dataSheet = select(".modal__data__sheet");
  const image = select(".modal__image") as HTMLAnchorElement | null;
  const swiper = select(".swiper");
  const seriesListContainer = select(".modal__series-list");

  // always reset
  if (title) title.innerHTML = "";
  if (description) description.innerHTML = "";
  if (dataSheet) dataSheet.innerHTML = "";
  if (image) {
    image.innerHTML = "";
    image.style.display = "";
    image.style.cursor = "";
    image.onclick = null;
  }
  if (seriesListContainer) seriesListContainer.innerHTML = "";

  // then create elements
  const h2 = create("h2");
  const p = create("p");
  const table = create("table");
  const img = create("img");

  let element: any = null;

  switch (options.section) {
    case "guitars":
      element = getInfo(elName);
      break;
    case "about":
      element = (locale as any)[elName] || (locale as any).filosofy;
      break;
    default:
      console.warn("[openModal]: No section provided.");
      break;
  }

  if (!element) {
    console.warn("[openModal]: No element found for", elName);
    return;
  }

  if (h2) h2.textContent = element.title ?? "";
  if (p) p.textContent = element.description ?? "";

  // Handle different data structures
  if (options.section === "about") {
    // For about section, hide data sheet and swiper
    if (table) table.innerHTML = "";
    if (img) {
      img.src = aboutImageMap[elName] ?? "";
      img.alt = element.title ?? "About Image";
      img.classList.add("no-hover");
    }

    // Hide swiper for about section
    if (swiper) swiper.style.display = "none";
    if (image) {
      image.style.display = "";
      image.href = "#";
      image.style.cursor = "default";
      image.onclick = (e) => {
        e.preventDefault();
      };
    }
  } else {
    // For guitars section
    if (table) table.innerHTML = element.table?.innerHTML ?? "";
    if (img) {
      img.src = element.images?.[0] ?? "";
      img.alt = element.title ?? "Guitar Image";
    }

    if (options.typology === "guitar") {
      // Hide swiper for individual guitars
      if (swiper) swiper.style.display = "none";
      if (image) {
        image.style.display = "";
        image.href = elName ? `./${elName}.html` : "#";
      }
    } else {
      // For series: hide modal__image, show swiper with cover images only
      if (image) {
        image.style.display = "none";
        image.style.cursor = "";
        image.onclick = null;
      }

      // Populate swiper with guitar cover images from the series
      const seriesKey = elName?.toLowerCase();
      const seriesData = (locale as any)[seriesKey];
      if (seriesData?.guitars && Array.isArray(seriesData.guitars) && swiper) {
        swiper.style.display = "";
        const swiperWrapper = select(".swiper-wrapper");
        if (swiperWrapper) {
          swiperWrapper.innerHTML = "";
          for (const guitarObj of seriesData.guitars) {
            const guitarKey = Object.keys(guitarObj)[0];
            const cover = (guitarCoverMap as any)[guitarKey];
            if (cover) {
              const div = create("div");
              if (div) {
                div.classList.add("swiper-slide");
                div.style.cursor = "pointer";
                const coverImg = create("img");
                if (coverImg) {
                  coverImg.src = cover;
                  coverImg.alt = guitarKey;
                  div.appendChild(coverImg);
                }
                // On click, dispatch custom event for app.js to handle map navigation
                div.addEventListener("click", () => {
                  document.dispatchEvent(
                    new CustomEvent("guitar-select", {
                      detail: { guitarName: guitarKey },
                    }),
                  );
                });
                swiperWrapper.appendChild(div);
              }
            }
          }
          // Destroy previous swiper if it exists
          if (state.swiperInstance) {
            state.swiperInstance.destroy(true, true);
            state.swiperInstance = null;
          }

          // Re-init swiper
          state.swiperInstance = new Swiper(".mySwiper", {
            modules: [Navigation, Pagination],
            slidesPerView: "auto",
            spaceBetween: 20,
            centeredSlides: true,
            centeredSlidesBounds: true,
            pagination: {
              el: ".swiper-pagination",
              clickable: true,
              enabled: false,
            },
          });

          // Placeholder for swiper
          for (let i = 0; i < 2; i++) {
            const placeholder = create("div");
            if (placeholder) {
              placeholder.classList.add(
                "swiper-slide",
                "swiper-slide--placeholder",
              );
              swiperWrapper.appendChild(placeholder);
            }
          }
          state.swiperInstance.update();
        }
      } else if (swiper) {
        swiper.style.display = "none";
      }
    }
  }

  if (title && h2) title.appendChild(h2);
  if (description && p) description.appendChild(p);
  if (dataSheet && table) dataSheet.appendChild(table);
  if (image && img) image.appendChild(img);
};

export default onOpenModal;
